export const initialState = {
    ingredients : null,
    totalPrice : 0,
    rawIngredients: null,
    purchasable: false,
    error: false,
    userModified: false
}
